'use strict';

angular.module("app").controller("GlobalController",["$scope","$window","tools","webservice","parameters","user","config",
                                                     function($scope,$window,tools,webservice,parameters,user,config) {
  $scope.tools = tools;
  $scope.webservice=webservice;
  $scope.parameters = parameters;
  $scope.user=user;
  $scope.config=config;

  user.lang=('lang' in $window.outdoorArgs)?$window.outdoorArgs.lang:'nl';
}]);
